import type { AssignableDocumentType } from '../types/documentTemplates.types';
import { DOCUMENT_TYPE_LABELS } from './documentTypeLabels';

export const missingTypeNames = (missing: readonly AssignableDocumentType[]): string =>
  missing.map((type) => DOCUMENT_TYPE_LABELS[type]).join(', ');

export const coverageBadgeLabel = (missing: readonly AssignableDocumentType[]): string =>
  missing.length === 0 ? 'All assigned' : `Missing ${missing.length}`;
